import { useEffect } from "react";

import { useAppDispatch, useAppSelector } from "../../../../store/service";
import { fetchHireflixLink } from "../../../Actions/RegisterTechActions";
import { useRegistrationContext } from "../registrationContext";

export const useHireflixLink = () => {
  const dispatch = useAppDispatch();
  const {
    registrationContext: { userId },
  } = useRegistrationContext();

  useEffect(() => {
    dispatch(fetchHireflixLink(userId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  const hireflixLink = useAppSelector((state: any) => state.registerTech.techData.hireflixLink);

  return hireflixLink;
};
